/**
 * Kiest de voordeligste kortingscode op basis van acties van productpagina's in de winkelwagen.
 * Kortingsbedrag / % alleen uit Shopify Cart API na valide code (niet compare_at).
 */
(function () {
  'use strict';

  var running = false;
  var debounceTimer = null;
  var lastCartFp = '';
  var MANUAL_KEY = 'uf_cart_discount_manual';
  var CACHE_KEY = 'uf_cart_best_discount_cache';

  function config() {
    return window.UF_CART_PROMO_CONFIG || {};
  }

  function normalizeCode(value) {
    return String(value || '').trim();
  }

  function isOfferteCode(value) {
    if (typeof window.ufCartIsOfferteLabel === 'function') return window.ufCartIsOfferteLabel(value);
    return /UF\d{6,}/i.test(normalizeCode(value).replace(/[^A-Za-z0-9]/g, '')) || /offerte/i.test(String(value || ''));
  }

  function isCalendarPromoName(value) {
    var cfg = config();
    var want = normalizeCode(value).toLowerCase();
    if (!want || isOfferteCode(value)) return false;
    var resolved = normalizeCode(cfg.resolvedCode || cfg.manualCode).toLowerCase();
    return !!resolved && want === resolved;
  }

  function cartHasOfferteCode(cart) {
    if (typeof window.ufCartHasOfferteDiscount === 'function') return window.ufCartHasOfferteDiscount(cart);
    if (!cart) return false;
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && isOfferteCode(codes[i].code)) return true;
    }
    var apps = cart.cart_level_discount_applications || [];
    for (var j = 0; j < apps.length; j++) {
      var title = apps[j] && (apps[j].title || apps[j].code);
      if (isOfferteCode(title)) return true;
    }
    return false;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function updateCartDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code || '' })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed');
      return res.json();
    });
  }

  function codeIsActive(cart, code) {
    if (!cart || !code) return false;
    var want = normalizeCode(code).toLowerCase();
    if (isCalendarPromoName(code) && cartHasOfferteCode(cart)) return false;

    if (cart.discount_codes && cart.discount_codes.length) {
      var match = cart.discount_codes.some(function (entry) {
        return entry && entry.code && String(entry.code).toLowerCase() === want && entry.applicable !== false;
      });
      if (match) return true;
    }

    if (isCalendarPromoName(code)) return false;

    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      return cart.cart_level_discount_applications.some(function (entry) {
        var label = entry && (entry.title || entry.code || '') ? String(entry.title || entry.code).toLowerCase() : '';
        return label && (label === want || (isOfferteCode(code) && label.indexOf(want) !== -1));
      });
    }

    return false;
  }

  function savingsForCode(cart, code) {
    if (!cart || !code || !codeIsActive(cart, code)) return 0;

    var want = normalizeCode(code).toLowerCase();
    var fromLines = 0;
    var hasLineMatch = false;

    if (cart.items && cart.items.length) {
      cart.items.forEach(function (item) {
        (item.discounts || []).forEach(function (d) {
          var title = d && d.title ? String(d.title).toLowerCase() : '';
          if (title && (title === want || title.indexOf(want) !== -1) && d.amount) {
            hasLineMatch = true;
            fromLines += d.amount;
          }
        });

        (item.line_level_discount_allocations || []).forEach(function (d) {
          var title = d && d.discount_application && d.discount_application.title
            ? String(d.discount_application.title).toLowerCase()
            : d && d.title
              ? String(d.title).toLowerCase()
              : '';
          if (title && (title === want || title.indexOf(want) !== -1) && d.amount) {
            hasLineMatch = true;
            fromLines += d.amount;
          }
        });
      });
    }

    if (hasLineMatch && fromLines > 0) return fromLines;
    if (cart.total_discount && cart.total_discount > 0) return cart.total_discount;
    return Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
  }

  function getDiscountMeta(cart, code) {
    if (!cart || !code) return null;
    var want = normalizeCode(code).toLowerCase();
    var apps = cart.cart_level_discount_applications || [];

    for (var i = 0; i < apps.length; i++) {
      var app = apps[i];
      if (!app) continue;
      var title = app.title ? String(app.title).toLowerCase() : '';
      if (title && (title === want || title.indexOf(want) !== -1)) {
        return app;
      }
    }

    if (cart.discount_codes && cart.discount_codes.length) {
      for (var j = 0; j < cart.discount_codes.length; j++) {
        var dc = cart.discount_codes[j];
        if (dc && dc.code && String(dc.code).toLowerCase() === want && dc.applicable !== false) {
          return { title: dc.code, value_type: 'code', applicable: true };
        }
      }
    }

    return null;
  }

  function actieHintText(cart) {
    var cents = 0;
    if (typeof window.ufCartDiscountBreakdown === 'function') {
      cents = window.ufCartDiscountBreakdown(cart).actieCents || 0;
    } else {
      cents = (cart && cart.total_discount) || 0;
    }
    if (!(cents > 0) || !window.Shopify || typeof Shopify.formatMoney !== 'function') return '';
    var money = Shopify.formatMoney(
      cents,
      (window.UF_CART_PROMO_CONFIG && window.UF_CART_PROMO_CONFIG.moneyFormat) || undefined
    );
    var html =
      typeof window.ufCartSavingsHtml === 'function'
        ? window.ufCartSavingsHtml(cart, money)
        : '+ ' + money + ' extra korting van de actie';
    var node = document.createElement('div');
    node.innerHTML = html;
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function formatDiscountHint(cart, code) {
    if (!cart || !code) return '';
    if (!(codeIsActive(cart, code) || cartHasOfferteCode(cart) || isOfferteCode(code))) return '';
    return actieHintText(cart);
  }

  function setFieldHint(code, cart) {
    document.querySelectorAll('[data-uf-cart-discount-field]').forEach(function (field) {
      var hint = field.querySelector('.uf-cart-discount-field__hint');
      if (!hint) return;
      if (!code || !cart) {
        hint.removeAttribute('data-uf-dynamic-hint');
        return;
      }
      var extra = formatDiscountHint(cart, code);
      if (extra) {
        hint.setAttribute('data-uf-dynamic-hint', '1');
        hint.textContent = extra;
      }
    });
  }

  function cartFingerprint(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';
    return cart.items
      .map(function (item) {
        var prop = '';
        if (window.UF_LF_PRODUCT_ACTIE && window.UF_LF_PRODUCT_ACTIE.getActieFromLineItem) {
          prop = window.UF_LF_PRODUCT_ACTIE.getActieFromLineItem(item) || '';
        }
        return String(item.variant_id) + 'x' + String(item.quantity) + ':' + prop;
      })
      .sort()
      .join('|');
  }

  function readCache(fp) {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || data.fp !== fp || !data.code) return null;
      if (data.date !== new Date().toDateString()) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(fp, code, savings) {
    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          fp: fp,
          code: code,
          savings: savings,
          date: new Date().toDateString()
        })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function syncInputs(code) {
    document.querySelectorAll('[data-uf-cart-discount-field] input[name="discount"]').forEach(function (input) {
      input.value = code || '';
    });
    try {
      if (code) localStorage.setItem('storedDiscount', code);
      else localStorage.removeItem('storedDiscount');
    } catch (e) {
      /* ignore */
    }
    if (typeof window.ufCartUpdateDiscountFieldUi === 'function') {
      window.ufCartUpdateDiscountFieldUi();
    }
  }

  function activeCodeFromCart(cart) {
    if (!cart) return resolveConfiguredCode();

    var offerteCode =
      typeof window.ufCartOfferteCodeFromCart === 'function' ? window.ufCartOfferteCodeFromCart(cart) : '';
    if (offerteCode) return offerteCode;
    if (cartHasOfferteCode(cart)) return '';

    if (cart.discount_codes && cart.discount_codes.length) {
      for (var i = 0; i < cart.discount_codes.length; i++) {
        var entry = cart.discount_codes[i];
        if (entry && entry.code && entry.applicable !== false) return entry.code;
      }
      if (cart.total_discount > 0) {
        for (var j = 0; j < cart.discount_codes.length; j++) {
          var anyEntry = cart.discount_codes[j];
          if (anyEntry && anyEntry.code) return anyEntry.code;
        }
      }
    }

    if (cart.total_discount > 0 && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      for (var k = 0; k < cart.cart_level_discount_applications.length; k++) {
        var app = cart.cart_level_discount_applications[k];
        if (app && (app.title || app.code)) return app.title || app.code;
      }
    }

    try {
      var stored = localStorage.getItem('storedDiscount');
      if (stored) return stored;
    } catch (e) {
      /* ignore */
    }

    if (cart.total_discount > 0) return resolveConfiguredCode();
    return '';
  }

  function resolveConfiguredCode() {
    var cfg = config();
    if (cfg.resolvedCode) return cfg.resolvedCode;
    if (cfg.manualCode) return cfg.manualCode;
    return '';
  }

  function syncDiscountUiFromCart(cart) {
    var code = activeCodeFromCart(cart);
    if (!code) return;
    syncInputs(code);
    syncFieldVisuals(code, cart);
    setFieldHint(code, cart);
  }

  function syncFieldVisuals(code, cart) {
    document.querySelectorAll('[data-uf-cart-discount-field]').forEach(function (field) {
      var input = field.querySelector('input[name="discount"]');
      var clearBtn = field.querySelector('[data-uf-cart-discount-clear]');
      var visibleCode = normalizeCode(code || (input && input.value));
      field.classList.remove('is-valid', 'is-invalid', 'is-checking', 'has-code');
      if (visibleCode) {
        field.classList.add('has-code');
        if (clearBtn) clearBtn.hidden = false;
      } else if (clearBtn) {
        clearBtn.hidden = true;
      }
      if (visibleCode && cart && codeIsActive(cart, visibleCode)) {
        field.classList.add('is-valid');
      }
    });
  }

  function refreshCartUi(cart) {
    if (typeof window.ufCartRefreshAfterDiscount === 'function') {
      window.ufCartRefreshAfterDiscount(cart);
      return;
    }
    if (typeof jQuery !== 'undefined') {
      jQuery(document.body).trigger('afterCartLoad.ajaxCart', [cart]);
    }
  }

  function getCandidatesFromCart(cart) {
    if (window.UF_LF_PRODUCT_ACTIE && typeof window.UF_LF_PRODUCT_ACTIE.resolveCandidatesFromCart === 'function') {
      return window.UF_LF_PRODUCT_ACTIE.resolveCandidatesFromCart(cart);
    }
    var cfg = config();
    var list = [];
    if (cfg.manualCode) list.push(cfg.manualCode);
    return list;
  }

  function evaluateCandidates(candidates) {
    var best = { code: '', savings: 0, cart: null };

    function tryNext(index) {
      if (index >= candidates.length) return Promise.resolve(best);

      var code = candidates[index];
      return updateCartDiscount(code)
        .then(function (cart) {
          var savings = savingsForCode(cart, code);
          if (savings > best.savings) {
            best = { code: code, savings: savings, cart: cart };
          }
          return tryNext(index + 1);
        })
        .catch(function () {
          return tryNext(index + 1);
        });
    }

    return updateCartDiscount('').then(function () {
      return tryNext(0).then(function () {
        if (!best.code || best.savings <= 0) {
          return updateCartDiscount('').then(function (cleared) {
            best.cart = cleared;
            return best;
          });
        }
        return updateCartDiscount(best.code).then(function (cart) {
          best.cart = cart;
          best.savings = savingsForCode(cart, best.code);
          return best;
        });
      });
    });
  }

  function applyBest(force) {
    var cfg = config();
    if (!cfg.enabled) return Promise.resolve(null);

    if (!force) {
      try {
        if (sessionStorage.getItem(MANUAL_KEY) === '1') return Promise.resolve(null);
      } catch (e) {
        /* ignore */
      }
    }

    if (running) return Promise.resolve(null);
    running = true;
    window.UF_CART_DISCOUNT_SCANNING = true;

    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) return null;

        if (cartHasOfferteCode(cart)) {
          try {
            sessionStorage.setItem(MANUAL_KEY, '1');
          } catch (e) {
            /* ignore */
          }
          var offerteCode =
            typeof window.ufCartOfferteCodeFromCart === 'function' ? window.ufCartOfferteCodeFromCart(cart) : '';
          if (offerteCode && typeof window.ufCartRememberOfferteCode === 'function') {
            window.ufCartRememberOfferteCode(offerteCode);
          }
          if (offerteCode) syncInputs(offerteCode);
          syncDiscountUiFromCart(cart);
          return cart;
        }

        var fp = cartFingerprint(cart);
        var candidates = getCandidatesFromCart(cart);

        if (!candidates.length) {
          syncInputs('');
          syncFieldVisuals('', null);
          setFieldHint('', null);
          return cart;
        }

        var cached = readCache(fp);
        if (cached && cached.code && candidates.some(function (c) {
          return c.toLowerCase() === cached.code.toLowerCase();
        })) {
          if (codeIsActive(cart, cached.code)) {
            syncInputs(cached.code);
            syncFieldVisuals(cached.code, cart);
            setFieldHint(cached.code, cart);
            refreshCartUi(cart);
            return cart;
          }
          return updateCartDiscount(cached.code).then(function (updated) {
            if (codeIsActive(updated, cached.code)) {
              syncInputs(cached.code);
              syncFieldVisuals(cached.code, updated);
              setFieldHint(cached.code, updated);
              refreshCartUi(updated);
              return updated;
            }
            return null;
          });
        }

        return evaluateCandidates(candidates).then(function (best) {
          if (!best.code || best.savings <= 0) {
            syncInputs('');
            syncFieldVisuals('', best.cart);
            setFieldHint('', best.cart);
            return best.cart || cart;
          }

          syncInputs(best.code);
          syncFieldVisuals(best.code, best.cart);
          setFieldHint(best.code, best.cart);
          writeCache(fp, best.code, best.savings);
          refreshCartUi(best.cart);
          return best.cart;
        });
      })
      .finally(function () {
        running = false;
        window.UF_CART_DISCOUNT_SCANNING = false;
        fetchCart()
          .then(function (cart) {
            lastCartFp = cart ? cartFingerprint(cart) : '';
            syncDiscountUiFromCart(cart);
          })
          .finally(function () {
            document.dispatchEvent(new CustomEvent('uf-cart-best-discount-done'));
          });
      });
  }

  function scheduleApply(force) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      applyBest(!!force);
    }, 280);
  }

  function markManual() {
    try {
      sessionStorage.setItem(MANUAL_KEY, '1');
      sessionStorage.removeItem(CACHE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function bindManualListeners() {
    document.addEventListener(
      'input',
      function (evt) {
        var input = evt.target;
        if (!input || input.name !== 'discount') return;
        if (!input.closest('[data-uf-cart-discount-field]')) return;
        markManual();
      },
      true
    );

    document.addEventListener(
      'click',
      function (evt) {
        if (evt.target.closest('[data-uf-cart-discount-clear]')) markManual();
      },
      true
    );
  }

  window.ufCartApplyBestDiscount = applyBest;
  window.ufCartSyncDiscountInputs = syncInputs;
  window.ufCartResolveDiscountCode = activeCodeFromCart;
  window.ufCartSyncDiscountUiFromCart = syncDiscountUiFromCart;

  document.addEventListener('DOMContentLoaded', function () {
    bindManualListeners();
    scheduleApply(false);
  });

  if (typeof jQuery !== 'undefined') {
    jQuery(document.body).on('afterCartLoad.ajaxCart', function (_evt, cart) {
      requestAnimationFrame(function () {
        syncDiscountUiFromCart(cart);
      });

      var fp = cart ? cartFingerprint(cart) : '';
      if (fp && fp === lastCartFp) {
        document.dispatchEvent(new CustomEvent('uf-cart-best-discount-done'));
        return;
      }
      lastCartFp = fp;
      scheduleApply(false);
    });
  }

  document.addEventListener('shopify:section:load', function () {
    scheduleApply(false);
  });
})();
